<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="92" height="88" viewBox="0 0 92 88">
    <defs>
        <linearGradient id="a" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#FFF"/>
            <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
        <path id="c" d="M60 66h8v8h-8z"/>
        <filter id="b" width="118.8%" height="118.8%" x="-9.4%" y="-9.4%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"/>
            <feOffset dx="-1" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feComposite in="shadowOffsetOuter1" in2="SourceAlpha" operator="out" result="shadowOffsetOuter1"/>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0.192136377 0 0 0 0 0.192169905 0 0 0 0 0.192129046 0 0 0 1 0"/>
        </filter>
        <linearGradient id="d" x1="50%" x2="50%" y1="41.129%" y2="66.71%">
            <stop offset="0%" stop-color="#D90338"/>
            <stop offset="100%" stop-color="#0069C4"/>
        </linearGradient>
    </defs>
    <g fill="none" fill-rule="evenodd">
        <path fill="url(#a)" stroke="#D9DDDF" stroke-width="2.25" d="M1.125 1.125h89.75v85.75H1.125z"/>
        <g fill="#313131" fill-rule="nonzero">
            <path d="M84.11 39.28H72.14v-1.14h5.7c.342 0 .57-.228.57-.57 0-.342-.228-.57-.57-.57h-6.27c-.342 0-.57.228-.57.57v12.54c0 .342.228.57.57.57h3.42c.342 0 .57-.228.57-.57v-6.27h8.55c.342 0 .57-.228.57-.57v-3.42c0-.342-.228-.57-.57-.57z"/>
            <path d="M80.12 48.4c0-1.083 1.71-2.85 1.71-2.85s1.71 1.767 1.71 2.85c0 1.083-.855 1.71-1.71 1.71s-1.71-.627-1.71-1.71z"/>
        </g>
        <path stroke="#0069C4" stroke-linecap="square" stroke-width="2.5" d="M63.589 78.795L63.5 54.5"/>
        <path stroke="#0069C4" stroke-dasharray="5" stroke-linecap="square" stroke-width="2.5" d="M8.5 57l55.125.125L63.5 28.5"/>
        <g stroke="#313131">
            <circle cx="5.831" cy="5.837" r="5.472" fill="#FFF" stroke-width="1.5" transform="translate(46 51)"/>
            <path stroke-linecap="square" stroke-width="1.4" d="M53 52l-5 5 4.5 4.5"/>
        </g>
        <g transform="rotate(45 64 70)">
            <use fill="#000" filter="url(#b)" xlink:href="#c"/>
            <use fill="#FFF" stroke="#313131" stroke-width="1.5" xlink:href="#c"/>
        </g>
        <path stroke="#D90338" stroke-linecap="square" stroke-width="2.5" d="M8.5 27l68 .29v5.5"/>
        <path fill="url(#d)" d="M13 19h30v51H13z"/>
        <path stroke="#FFF" stroke-linecap="square" stroke-width="2.4" d="M9.5 75.5l36-61" opacity=".7"/>
    </g>
</svg>
